import React, { useEffect } from 'react';

import Heading from '@tds/core-heading';
import DimpleDivider from '@tds/core-dimple-divider';

import { Container, Wrapper } from './css';
import NewPhoneNumberCheck from './newPhoneNumberCheck';
import ExistingPhoneNumberCheck from './existingPhoneNumberCheck';

import { useLocalizedStringsContext } from '../context/LocalizedStringsContext';

const PhonePortingTool = () => {
  const localizedStrings = useLocalizedStringsContext();
  const {
    portabilityTool: { labelCheckService }
  } = localizedStrings;

  useEffect(() => {
    document.getElementById('footer').style.position = 'fixed';
    document.getElementById('footer').style.bottom = '0';

    return () => {
      document.getElementById('footer').style.position = null;
      document.getElementById('footer').style.bottom = null;
    };
  }, []);

  return (
    <Container>
      <Heading level="h1" tag="h2">
        {labelCheckService}
      </Heading>
      <Wrapper>
        <NewPhoneNumberCheck />
        <DimpleDivider />
        <ExistingPhoneNumberCheck />
      </Wrapper>
    </Container>
  );
};

export default PhonePortingTool;
